import { useEffect, useRef } from 'react';
import { useLoading } from '~/lib/contexts/LoadingContext';
import { useLocation } from '@remix-run/react';

export const UrlChangeManager = () => {
    const { hideSpinner } = useLoading();
    const location = useLocation();
    const previousUrlRef = useRef<string>('');

    useEffect(() => {
        const currentUrl = location.pathname + location.search;

        if (previousUrlRef.current !== '' && previousUrlRef.current !== currentUrl) {
            hideSpinner();
        }

        previousUrlRef.current = currentUrl;
    }, [location.pathname, location.search, hideSpinner]);

    useEffect(() => {
        const clearSpinnerOnHistoryNavigation = () => {
            hideSpinner();
        };

        // Browser back/forward navigation.
        window.addEventListener('popstate', clearSpinnerOnHistoryNavigation);
        // Handles bfcache restores where React state may be preserved.
        window.addEventListener('pageshow', clearSpinnerOnHistoryNavigation);

        return () => {
            window.removeEventListener('popstate', clearSpinnerOnHistoryNavigation);
            window.removeEventListener('pageshow', clearSpinnerOnHistoryNavigation);
        };
    }, [hideSpinner]);

    return null; // This component doesn't render anything
};
